// extracted by mini-css-extract-plugin
export default {"header":"RegionList_header__iZPTf","item":"RegionList_item__7Tbdv","tag":"RegionList_tag__G9ms4"};